import { render, staticRenderFns } from "./groupRecord.vue?vue&type=template&id=c89a0644&scoped=true&"
import script from "./groupRecord.vue?vue&type=script&lang=js&"
export * from "./groupRecord.vue?vue&type=script&lang=js&"
import style0 from "./groupRecord.vue?vue&type=style&index=0&id=c89a0644&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89a0644",
  null
  
)

export default component.exports